import { getWorkOrderResources } from "../../repositories/WorkOrderResourcesRepository";
import { get } from "lodash-es";

type Props = {
	WorkOrderId: number | null;
	setWorkOrderAttachmentsList: Function;
	setIsLoadingWorkOrderResourcesList: (isLoading: boolean) => void;
	setErrorWorkOrderResourcesList: (err: string) => void;
};

export const useSearchWorkOrderResources = ({
	WorkOrderId,
	setWorkOrderAttachmentsList,
	setIsLoadingWorkOrderResourcesList,
	setErrorWorkOrderResourcesList,
}: Props) => {
	return async () => {
		setIsLoadingWorkOrderResourcesList(true);
		const res = await getWorkOrderResources(WorkOrderId as number);
		if (res.ok) {
			// Simplified: GetWorkOrderResources now returns only attachments (single table)
			const workOrderAttachmentsList = get(res, "data.tables[0].rows", []);
			setWorkOrderAttachmentsList(workOrderAttachmentsList);
			setIsLoadingWorkOrderResourcesList(false);
		} else {
			setIsLoadingWorkOrderResourcesList(false);
			setErrorWorkOrderResourcesList(res.message);
		}
	};
};
